import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../Vas';
import ReactDOM from 'react-dom';
import '../../css/Account.css';
import { ExtendedButton,TextField,ConfirmBox,Loading } from 'component-lib';
import { RoleConfiguration,DateTimeHelper } from 'utils-lib';
import { RequestAjaxClass, AccountsModel } from 'models-lib';

class Account extends Component
{
    constructor(props){
        super(props);
        this.state = {};
        this.state.ChangePassword = false;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.AccountsModel = new AccountsModel([this]);
    }

    componentWillMount(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
    }

    componentDidMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        this.AccountsModel.SetRequest(this.Request);

        this.AccountsModel.Own();

        $("#HeaderTitle").html(Vas.Resources.Menus["Account"]);

        document.getElementById("Name1").onselectstart = function(){return false;};
        document.getElementById("Name1").onmousedown = function(){return false;};

        document.getElementById("Name2").onselectstart = function(){return false;};
        document.getElementById("Name2").onmousedown = function(){return false;};

        document.getElementById("Gender").onselectstart = function(){return false;};
        document.getElementById("Gender").onmousedown = function(){return false;};

        document.getElementById("DateOfBirth").onselectstart = function(){return false;};
        document.getElementById("DateOfBirth").onmousedown = function(){return false;};

        document.getElementById("Zip").onselectstart = function(){return false;};
        document.getElementById("Zip").onmousedown = function(){return false;};

        document.getElementById("City").onselectstart = function(){return false;};
        document.getElementById("City").onmousedown = function(){return false;};

        document.getElementById("Street").onselectstart = function(){return false;};
        document.getElementById("Street").onmousedown = function(){return false;};

        document.getElementById("HouseNumber").onselectstart = function(){return false;};
        document.getElementById("HouseNumber").onmousedown = function(){return false;};
        // eslint-disable-next-line
        document.onselectstart = new Function ('return false');

        ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "AccountsOwn"){
          let value = this.AccountsModel.Customer;
          me.refs.CustomerNumber.setState({ Value:value.CustomerNumber });
          me.refs.Name.setState({ Value: value.Name1 });
          me.refs.FirstName.setState({ Value:value.Name2 });
          me.refs.Gender.setState({ Value:value.Gender });
          me.refs.DateOfBirth.setState({ Value:DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateOfBirth,true,localStorage.getItem('vas_language'))) });
          me.refs.Street.setState({ Value:value.Street });
          me.refs.HouseNumber.setState({ Value:value.HouseNumber });
          me.refs.Zip.setState({ Value:value.PostCode });
          me.refs.Place.setState({ Value:value.City });
        }
        else if( observer === "DeleteAccounts"){
          ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            Vas.clearLocalStorage();
            window.location = Vas.ApplicationUrl;
        }
      });
    }

    Delete(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        //Löschen des Accounts
        this.AccountsModel.DeleteAccount(localStorage.getItem('vas_userId'));
    }

    showChangePassword(){
      Vas.GetView('ChangePassword',null,true);
    }

    render(){
        let role = localStorage.getItem("vas_role");
        let rights = RoleConfiguration.getRoleConfig();
        let button = '';
        if (role === "1" || role ==="99"){
            if (rights[5]){
                if (rights[5].Delete === true)
                {
                    button = (<ExtendedButton
                      Usable={true}
                      Width={170}
                      className={"changePwdButton"}
                      Text={Vas.Resources.Labels["DropAccount"]} 
                      OnClick={()=>{ ReactDOM.render(<ConfirmBox
                        AppURL={Vas.ApplicationUrl}
                        LabelConfirm={Vas.Resources.Labels["Confirm"]}
                        LabelCancel={Vas.Resources.Labels["Cancel"]}
                        modal={true}
                        MessageText={Vas.Resources.Labels["ConfirmDeleteAccount"]}
                        Click={()=>{this.Delete();}} /> , document.getElementById('messageContainer'));}}  />);
                } else {
                    button = (<ExtendedButton
                      Usable={false}
                      Width={170}
                      className={"changePwdButton"}
                      Text={Vas.Resources.Labels["DropAccount"]} />);
                } 
            }
        }
        
        let chPassword = '';
        if (rights[5]){
            if (rights[5].Edit === true){
                chPassword = (<ExtendedButton
                  Usable={true}
                  Width={170}
                  className={"changePwdButton"}
                  Text={Vas.Resources.Labels["ChangePassword"]}
                  OnClick={()=>{ this.showChangePassword();}}  />);
            } else {
                chPassword = (<ExtendedButton
                  Usable={false}
                  Width={170}
                  className={"changePwdButton"}
                  Text={Vas.Resources.Labels["ChangePassword"]} 
                  />);
            } 
        }
        
        return (
          <div className={"form"}>
            <table>
              <tbody>
                <tr>
                  <td><TextField
                    ref={"CustomerNumber"}
                    Id={"CustomerNumber"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["CustomerNumber"]} /></td>
                        
                </tr>
                <tr>
                  <td><TextField
                    ref={"Name"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Name"]}
                    Id={"Name1"} /></td>
                  <td><TextField
                    ref={"FirstName"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["FirstName"]}
                    Id={"Name2"} /></td>
                </tr>
                <tr>
                  <td><TextField
                    ref={"Gender"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Gender"]}
                    Id={"Gender"} /></td>
                  <td><TextField
                    ref={"DateOfBirth"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["DateOfBirth"]}
                    Id={"DateOfBirth"} /></td>
                </tr>
                <tr>
                  <td><TextField
                    ref={"Street"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Street"]}
                    Id={"Street"} /></td>
                  <td><TextField
                    ref={"HouseNumber"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["HouseNumber"]}
                    Id={"HouseNumber"} /></td>
                </tr>
                <tr>
                  <td><TextField
                    ref={"Zip"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Zip"]}
                    Id={"Zip"} /></td>
                  <td><TextField
                    ref={"Place"}
                    AppURL={Vas.ApplicationUrl}
                    Label={Vas.Resources.Labels["Place"]}
                    Id={"City"} /></td>
                </tr>
                <tr>
                  <td>{chPassword}</td>
                  <td>{button}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
    }
}
export default Account;
